module.exports = __webpack_public_path__ + "img/31.e7c90fda.jpg";